var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-img',{staticClass:"mr-3",attrs:{"src":_vm.image,"contain":"","eager":"","max-height":"55","max-width":"55"}})
}
var staticRenderFns = []

export { render, staticRenderFns }